export const prepareSectionsList = (sections) => {
	return sections.map(({ name, label, id }) => {
		return { value: id, name: `${name} (${label})` };
	});
};
